<template>
  <div id="app">
    <nav
      class="flex items-center justify-between w-full fixed top-0 left-0">
      <Logo class="logo-text" v-if="$route.meta.nav !== false" />
      <!-- <h1 class="pt-3 ms-2">ӘИIꓷOƆ ƎƧЯƎVƎЯ</h1> -->
      <img src="@/assets/rubix logo black.png" alt="" class="mr-3 ms-3 h-6 mt-4 mb-4 logo-animate"/>
    </nav>
    <router-view/>
      <transition name="fade">
      <div id="loading" v-if="loading" class="
        min-h-screen
        w-full
        flex
        flex-col items-center justify-center fixed top-0 left-0 bg-white z-50
        ">
        <Logo class="mb-44"/>
        <svg class="spinner" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Logo from '@/components/Logo.vue';

export default {
  data() {
    return {
    };
  },
  components: {
    Logo,
  },
  computed: {
    ...mapGetters({ loading: 'GET_LOADING' }),
  },
  created() {
  },
};
</script>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav{
    // background: linear-gradient(121.57deg, #FFFFFF 18.77%, rgba(255, 255, 255, 0.66) 60.15%);
    background: linear-gradient(90deg, #3300ff, #e52e71 );
}
body{
    // background-color: #1d1d1f !important;
    background-color: #0B141D !important;
}
h1{
  font-weight: 700;
  font-family: Poppins, 'sans-serif';
  background: linear-gradient(121.57deg, #000000 18.77%, rgba(0, 0, 0, 0.66) 60.15%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

}
.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  & .path {
    stroke: rgb(31, 41, 55);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
.fade-enter-active,
.fade-leave-active {
    transition: all 1s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateY(35px);
    background: transparent;
}
.appear-enter-active,
.appear-leave-active {
    transition: all ease .5s;
}
.appear-enter,
.appear-leave-to {
    opacity: 0;
}
.conjure-enter-active,
.conjure-leave-active {
    transition: all 1s ease-in-out;
}
.conjure-enter,
.conjure-leave-to {
    opacity: 0;
    transform: translateY(35px);
    background: transparent;
}
.logo-animate {
  animation: conjure 2s ease-in-out 0s 1 alternate;
  width: auto;
}
 /* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

</style>
